import {
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { AlertMargin } from "App/global-style";
import { VALUE_TYPE } from "Components/NumberValue";
import { formatToLocaleString } from "Formatting/formatNumber";
import { getPaymentRestriction } from "Store/akaAdvice/interfaces/getters";
import React from "react";
import { PurchaseFromAdvisorAlert } from "./PurchaseFromAdvisorAlert";

interface Props {
  need: CoverageNeed;
  purchaseFromAdvisor: any;
  lang: string;
  maxAdvisorAdviceValue: number;
  maxAdvisorAdviceOtpValue: number;
  marginBottom?: AlertMargin;
}

export const PurchaseFromAdvisorOneTimePaymentOnly = ({
  need,
  purchaseFromAdvisor,
  lang,
  maxAdvisorAdviceOtpValue,
  marginBottom,
}: Props): React.ReactElement => {
  const { oneTime } = purchaseFromAdvisor.payment;
  const singlePaymentText = `${formatToLocaleString(
    maxAdvisorAdviceOtpValue,
  )} ${VALUE_TYPE.NOK}`;
  const otpPaymentRestriction = getPaymentRestriction(
    need,
    ProductCoverageName.DISABILITY_FLEX_CAPITAL,
  );

  return (
    <PurchaseFromAdvisorAlert
      customMaximumPayoutText={
        maxAdvisorAdviceOtpValue ===
        otpPaymentRestriction.maxPayouts.PRODUCT_MANAGER
          ? purchaseFromAdvisor.isMaximumPayoutOneTime[lang]
          : ""
      }
      customText={oneTime[lang].replace("{{value}}", singlePaymentText)}
      purchaseFromAdvisor={purchaseFromAdvisor}
      lang={lang}
      marginBottom={marginBottom}
    />
  );
};
